import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import axios from "../../../redux/axios/axios.js";
import "../commonCSS.css";

const validationSchema = Yup.object().shape({
  email: Yup.string().matches(
    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
    "Invalid email address"
  ),
});

function ForgetPassword() {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        const response = await axios.post(
          "http://192.168.0.156:8000/api/v1/users/forgot/password",
          { email: values.email }
        );
        if (response.data.success) {
          alert("Password reset link has been sent to your email.");
          navigate("/reset-password");
        } else {
          alert("Error sending reset link.");
        }
      } catch (error) {
        console.error("Error: ", error);
        alert("Something went wrong.");
      }
    },
  });

  return (
    <section className="vh-100 forget-background bg-gradient">
      <div className="container h-100 d-flex justify-content-center align-items-center ">
        <div className="row w-100 justify-content-center ">
          <div className="col-md-8 col-lg-6 col-xl-5 ">
            <div className="card shadow-lg border-0 rounded-4 background-dark">
              <div class="arrow-auth">
                <Link to="/login">
                  {" "}
                  <i class="bi bi-arrow-left text-dark fs-5 landing-text-white"></i>
                </Link>
              </div>
              <div className="card-body p-5">
                <h2 className="text-center mb-4 font-weight-bold text-primary fs-4">
                  Forgot Your Password?
                </h2>
                <p className="text-center mb-4 fs-6 text-muted landing-text-white">
                  No worries! Enter your email, and we'll send you a link to
                  reset your password.
                </p>
                <form onSubmit={formik.handleSubmit}>
                  <div className="mb-4">
                    <label htmlFor="email" className="form-label landing-text-white">
                      Email Address
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder="Enter Your Email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="text-danger mt-2">
                        {formik.errors.email}
                      </div>
                    )}
                  </div>
                  <div className="d-grid gap-2 mb-4">
                    <button type="submit" className="btn btn-primary btn-lg">
                      Send Reset Link
                    </button>
                  </div>
                </form>
                <div className="text-center">
                  <p className="text-center fs-6 landing-text-white">
                    Remember your password?{" "}
                    <Link
                      to="/login"
                      className="text-decoration-none text-primary"
                    >
                      Login here
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ForgetPassword;
